import { ApiResponse, apiCall } from "./apiClient";
import { TransportOrderProductListItemDto } from "../models/transport/transportOrderProduct";

export const getTransportOrderProducts = (): Promise<ApiResponse<TransportOrderProductListItemDto[]>> => {
    return apiCall<TransportOrderProductListItemDto[]>("Products", "GET");
};
